import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  sub?: string;
  // Optional right-aligned actions (buttons, etc.).
  actions?: ReactNode;
}

// The standard page heading block: large display title + muted subtitle, optional actions.
// Wraps to a second row on narrow screens — the actions slot routinely holds a full-width button
// group, and a non-wrapping row squeezed the title into two or three characters per line on a
// phone. `items-end` only applies once they're side by side again.
export function PageHeader({ title, sub, actions }: PageHeaderProps) {
  return (
    <div className="mb-5 flex flex-wrap items-start justify-between gap-x-5 gap-y-3 sm:mb-6 sm:flex-nowrap sm:items-end">
      <div className="min-w-0">
        {/* A 34px display face is ~7 characters across a 375px viewport once the shell's padding is
            taken off; step it down so page titles stay one or two lines on a phone. */}
        <h1 className="font-display text-[26px] leading-[1.08] text-ink sm:text-[34px] sm:leading-[1.05]">
          {title}
        </h1>
        {sub && <p className="mt-1.5 text-[13px] text-muted sm:text-sm">{sub}</p>}
      </div>
      {actions}
    </div>
  );
}
